import { useEffect, useState } from "react";
import {
  Button,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
  Tooltip,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { Workspaces } from "@mui/icons-material";
import { getFleets } from "../../endpoints/configuratorApi";

type MachineNameProps = {
  handleNext: (fleetId: string) => void;
};
const MachineName: React.FC<MachineNameProps> = ({ handleNext }) => {
  const { t } = useTranslation();

  const [fleets, setFleets] = useState<any[]>([]);
  const [fleetId, setFleetId] = useState<string>("");

  useEffect(() => {
    getFleets().then((res: any) => {
      if (res && res.fleets) {
        setFleets([...res.fleets]);
      }
    });
  }, []);

  return (
    <Grid
      container
      spacing={2}
      direction="column"
      alignItems="center"
      justifyContent="center"
      textAlign="center"
    >
      <Grid item>
        <Workspaces style={{ fontSize: "64px" }} />
      </Grid>
      <Grid item>
        <Typography variant="h5">{t("selectFleet")}</Typography>
      </Grid>
      <Grid item>
        <Typography>{t("selectFleetDescription")}</Typography>
      </Grid>
      <Grid
        container
        item
        spacing={4}
        alignItems="center"
        justifyContent="center"
      >
        <Grid item xs={12} md={8} xl={6}>
          <Grid container spacing={1} direction="column">
            <Grid item>
              <FormControl fullWidth style={{ textAlign: "start" }}>
                <InputLabel id="select-label">{t("fleet")}</InputLabel>
                <Select
                  labelId="select-label"
                  value={fleetId}
                  label={t("fleet")}
                  onChange={(event: SelectChangeEvent) =>
                    setFleetId(event.target.value as string)
                  }
                >
                  {fleets.length > 0 &&
                    fleets.map((f) => (
                      <MenuItem value={f.id}>{f.name}</MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Grid>
            <Grid item>
              <Grid
                container
                spacing={2}
                display="flex"
                alignItems="flex-start"
                justifyContent="space-between"
              >
                <Grid item xs></Grid>
                <Tooltip title={fleetId ? "" : `${t("fillInAllFields")}`}>
                  <Grid item>
                    <Button
                      data-testid="next"
                      disabled={!fleetId}
                      size="large"
                      variant="contained"
                      style={{ float: "right", marginTop: "8px" }}
                      onClick={() => handleNext(fleetId)}
                    >
                      {t("next")}
                    </Button>
                  </Grid>
                </Tooltip>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default MachineName;
